export default "__VITE_ASSET__74dcdde6__"